// AURAX_REDESIGN_2710 (GROK2): clone enxuto do TesteRapidoModal — mostra o teste já gerado,
// copiar mensagem e o formulário OPCIONAL "completar dados" (nome + WhatsApp) depois do teste.
// O TesteRapidoModal antigo continua intacto.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Copy, Loader2 } from 'lucide-react';
import { API_BASE_URL } from '../apiBase';
import { formatApiError } from '../context/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent } from './ui/dialog';
import InternationalPhoneField from './InternationalPhoneField';
import { useConfirmedPhone } from '../lib/confirmedPhone';

export default function TesteRapidoUmClique({ result, onClose }) {
  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  const phone = useConfirmedPhone(whatsapp);

  useEffect(() => { setNome(''); setWhatsapp(''); setSaved(false); setCopied(false); }, [result?.one_click_id]);

  if (!result) return null;
  const msg = String(result.template_msg || '').trim()
    || `Usuário: ${result.username || ''}\nSenha: ${result.password || ''}\nVencimento: ${result.exp_date_formatted || ''}`;

  const copy = async () => {
    try { await navigator.clipboard.writeText(msg); setCopied(true); toast.success('Mensagem copiada.'); }
    catch { toast.error('Não foi possível copiar.'); }
  };

  const save = async () => {
    if (nome.trim().length < 2) return toast.error('Informe o nome.');
    if (!phone.ready) return toast.error(phone.error);
    setSaving(true);
    try {
      await axios.post(
        `${API_BASE_URL}/api/xui/lines/${encodeURIComponent(result.username)}/complete-trial-contact`,
        { nome: nome.trim(), whatsapp: phone.digits, one_click_id: result.one_click_id },
        { withCredentials: true, timeout: 30000 },
      );
      setSaved(true);
      toast.success('Dados do cliente gravados.');
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || 'Não foi possível gravar os dados.');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!result} onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent className="max-w-lg">
        <h3 className="text-lg font-semibold">Teste {result.app?.name || ''} gerado ✅</h3>
        <pre className="max-h-72 overflow-auto whitespace-pre-wrap rounded-lg bg-muted p-3 text-xs">{msg}</pre>
        <Button type="button" onClick={copy} className="w-full">
          {copied ? <Check className="mr-2 h-4 w-4" /> : <Copy className="mr-2 h-4 w-4" />}Copiar mensagem
        </Button>
        <div className="mt-2 space-y-2 rounded-lg border p-3">
          <p className="text-sm font-medium">Completar dados do cliente (opcional, pode ser depois)</p>
          {saved ? <p className="text-sm text-emerald-600">Dados gravados.</p> : (
            <>
              <div><Label htmlFor="t1c-nome">Nome</Label>
                <Input id="t1c-nome" value={nome} onChange={(e) => setNome(e.target.value)} disabled={saving} /></div>
              <div><Label htmlFor="t1c-wa">WhatsApp</Label>
                <InternationalPhoneField id="t1c-wa" value={whatsapp} onChange={setWhatsapp} confirmation={phone} disabled={saving} /></div>
              <Button type="button" variant="outline" onClick={save} disabled={saving} className="w-full">
                {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}Gravar dados
              </Button>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
